/*
  HomePage component for FullStack.cash
*/

import React from 'react'
import { Helmet } from 'react-helmet-async'
import { Link } from 'react-router-dom'
import { Container, Row, Col, Button, Card } from 'react-bootstrap'

import cashstack from '../assets/images/cashstack.gif'
import cashStackPoster from '../assets/images/cash-stack-poster.png'

// Company Logos
import logoBitfinex from '../assets/images/bitfinex-logo.png'
import logoSweet from '../assets/images/sweet.png'
import logoSideshift from '../assets/images/sideshift.png'
import logoLaunchpad from '../assets/images/launchpad.png'
import logoBitcoincom from '../assets/images/bitcoin.com.png'
import logoEcash from '../assets/images/ecash2.png'
import logoAvalabs from '../assets/images/ava-labs.png'
import logoOwnrare from '../assets/images/ownrare-logo.png'
import logoShoemaker from '../assets/images/shoemaker360-logo.png'

function HomePage () {
  const siteTitle = 'BCH Blockchain As-A-Service SaaS'

  return (
    <>
      <Helmet>
        <title>{siteTitle}</title>
      </Helmet>

      <Container fluid className='py-5'>
        <Row className='mb-5 align-items-center'>
          <Col md={6} className='mb-4 mb-md-0'>
            <img src={cashstack} alt='Cash Stack' className='img-fluid' />
          </Col>
          <Col md={5}>
            <h2 className='display-4'>FullStack.Cash</h2>
            <h3 className='h4 mb-4'>BCH Blockchain As-A-Service</h3>
            <h4 className='h5 mb-4'>
              We offer commercial access to
              the <a href='https://cashstack.info' target='_blank' rel='noreferrer'>Cash Stack</a>, which
              allows phone and web apps to
              interact with the Bitcoin Cash blockchain.
            </h4>
            <div className='mb-3'>
              <Button as={Link} to='/apis' variant='primary' size='lg'>
                REST APIs
              </Button>
            </div>
            <div className='mb-3'>
              <Button as={Link} to='/pricing' variant='outline-primary' size='lg'>
                Private Infrastructure
              </Button>
            </div>
            <div className='mb-3'>
              <Button as={Link} to='/cash-box' variant='outline-secondary' size='lg'>
                Cash Box
              </Button>
            </div>
          </Col>
        </Row>

        <Row className='mb-5'>
          <Col>
            <img src={cashStackPoster} alt='Cash Stack Poster' className='img-fluid' />
          </Col>
        </Row>

        <div className='mb-5 py-4' style={{ backgroundColor: '#e9ecef' }}>
          <Row>
            <Col>
              <h2 className='text-center mb-4'>Quick Start Examples</h2>
            </Col>
          </Row>
          <Row>
            <Col md={12}>
              
              <div style={{ paddingLeft: '15px', paddingRight: '15px' }}>
                <p>
                  If you want to quickly get started coding and working with the Bitcoin Cash blockchain, 
                  we have a collection of code examples to do just that.
                </p>
                <p>
                  These examples show how to perform common use-cases:
                </p>

                <ul>
                  <li>Creating a wallet</li>
                  <li>Sending and receiving BCH</li>
                  <li>Creating and sending SLP tokens</li>
                  <li>Reading and writing text to the blockchain</li>
                  <li>Burning tokens</li>
                  <li>Price BCH in USD</li>
                  <li>Sending messages on the blockchain via OP_RETURN data</li>
                  <li>Retrieve transaction data</li>
                  <li>And more!</li>
                </ul>

              </div>
              
              <div className='mt-3 text-center'>
                <Button
                  variant='primary'
                  as='a'
                  href='https://github.com/Permissionless-Software-Foundation/psf-js-examples'
                  target='_blank'
                  rel='noopener noreferrer'
                >
                  Code Examples
                </Button>
              </div>
            </Col>
          </Row>
        </div>

        <Row className='mb-5'>
          <Col>
            <h2 className='text-center mb-4'>FullStack.cash Products</h2>
          </Col>
        </Row>

        <Row className='mb-5'>
          <Col md={4} className='mb-4 mb-md-0'>
            <Card className='h-100 text-center'>
              <Card.Body>
                <i className='fas fa-code fa-3x text-primary mb-3' />
                <Card.Title>REST APIs</Card.Title>
                <Card.Text>
                  Production-ready blockchain infrastructure APIs for interacting with Bitcoin Cash.
                  Choose from high-bandwidth production APIs to free rate-limited versions for every development need.
                </Card.Text>
                <Button as={Link} to='/apis' variant='outline-primary'>
                  More
                </Button>
              </Card.Body>
            </Card>
          </Col>
          <Col md={4} className='mb-4 mb-md-0'>
            <Card className='h-100 text-center'>
              <Card.Body>
                <i className='fas fa-server fa-3x text-primary mb-3' />
                <Card.Title>Private Infrastructure</Card.Title>
                <Card.Text>
                  Hosted private, customized infrastructure for larger clients. Each isolated instance
                  supports up to 2 million API requests per day with full Cash Stack services.
                </Card.Text>
                <Button as={Link} to='/pricing' variant='outline-primary'>
                  More
                </Button>
              </Card.Body>
            </Card>
          </Col>
          <Col md={4}>
            <Card className='h-100 text-center'>
              <Card.Body>
                <i className='fas fa-cube fa-3x text-primary mb-3' />
                <Card.Title>Cash Box</Card.Title>
                <Card.Text>
                  Your personal blockchain server appliance. A Raspberry Pi 5-based device that runs
                  the complete Cash Stack locally with no rate limits - all for under $1,000 USD.
                </Card.Text>
                <Button as={Link} to='/cash-box' variant='outline-primary'>
                  More
                </Button>
              </Card.Body>
            </Card>
          </Col>
        </Row>

        <div className='mb-5 py-4' style={{ backgroundColor: '#e9ecef' }}>
          <Row>
            <Col>
              <h2 className='text-center mb-4'>Tech Support</h2>
            </Col>
          </Row>
          <Row>
            <Col md={12}>
              
              <div style={{ paddingLeft: '15px', paddingRight: '15px' }}>
                <p>
                  Our Telegram chat room is a great place to get help with any questions you have about the Cash Stack or any of our products.
                  We also have a chat bot that can answer questions and help you with your code.
                </p>
                
              </div>
              
              <div className='mt-3 text-center'>
                <Button
                  variant='primary'
                  as='a'
                  href='https://t.me/bch_js_toolkit'
                  target='_blank'
                  rel='noopener noreferrer'
                >
                  Join Our Telegram Channel
                </Button>
              </div>
            </Col>
          </Row>
        </div>

        <Row className='mb-5'>
          <Col>
            <h2 className='text-center mb-4'>Organizations That Have Used FullStack.cash Infrastructure</h2>
          </Col>
        </Row>

        <Row className='g-4'>
          <Col md={4} className='text-center'>
            <h3>Bitfinex & Tether</h3>
            <a href='https://bitfinex.com' target='_blank' rel='noreferrer'>
              <img src={logoBitfinex} alt='Bitfinex' className='img-fluid' />
            </a>
          </Col>
          <Col md={4} className='text-center'>
            <h3>Sweet</h3>
            <a href='https://sweet.io' target='_blank' rel='noreferrer'>
              <img src={logoSweet} alt='Sweet' className='img-fluid' />
            </a>
          </Col>
          <Col md={4} className='text-center'>
            <h3>SideShift.ai</h3>
            <a href='https://sideshift.ai' target='_blank' rel='noreferrer'>
              <img src={logoSideshift} alt='SideShift' className='img-fluid' />
            </a>
          </Col>
          <Col md={4} className='text-center'>
            <h3>Launchpad IP</h3>
            <a href='https://launchpadip.com' target='_blank' rel='noreferrer'>
              <img src={logoLaunchpad} alt='Launchpad IP' className='img-fluid' />
            </a>
          </Col>
          <Col md={4} className='text-center'>
            <h3>Bitcoin.com</h3>
            <a href='https://bitcoin.com' target='_blank' rel='noreferrer'>
              <img src={logoBitcoincom} alt='Bitcoin.com' className='img-fluid' />
            </a>
          </Col>
          <Col md={4} className='text-center'>
            <h3>eCash GNC</h3>
            <a href='https://e.cash' target='_blank' rel='noreferrer'>
              <img src={logoEcash} alt='eCash' className='img-fluid' />
            </a>
          </Col>
          <Col md={4} className='text-center'>
            <h3>Ava Labs</h3>
            <a href='https://www.avalabs.org/' target='_blank' rel='noreferrer'>
              <img src={logoAvalabs} alt='Ava Labs' className='img-fluid' />
            </a>
          </Col>
          <Col md={4} className='text-center'>
            <h3>OwnRare.Art</h3>
            <a href='https://ownrare.art' target='_blank' rel='noreferrer'>
              <img src={logoOwnrare} alt='OwnRare' className='img-fluid' />
            </a>
          </Col>
          <Col md={4} className='text-center'>
            <h3>Shoemaker360</h3>
            <a href='https://shoemaker360.com' target='_blank' rel='noreferrer'>
              <img src={logoShoemaker} alt='Shoemaker360' className='img-fluid' />
            </a>
          </Col>
        </Row>
      </Container>
    </>
  )
}

export default HomePage
